import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Teléfonos chilenos en el navegador.
 *
 * Misma regla que el backend (`src/common/telefono/telefono.ts`): nueve
 * dígitos después del +56, que no empiecen en 0 ni en 1 porque no abren
 * ningún número marcable. Acá vive para poder decirlo mientras se escribe.
 *
 * El +56 no se tipea: va fijo al lado del campo. Quien carga su número no
 * tiene por qué decidir si lo escribe con +, con 0056 o sin nada.
 */

/** Los nueve dígitos nacionales, sin país ni separadores. */
export function soloDigitosNacionales(valor: string): string {
  let d = (valor ?? '').replace(/\D/g, '');
  if (d.startsWith('0056')) d = d.slice(4);
  else if (d.startsWith('56') && d.length > 9) d = d.slice(2);
  if (d.startsWith('0')) d = d.slice(1);
  return d.slice(0, 9);
}

export function esTelefonoChilenoValido(valor: string): boolean {
  return /^[2-9]\d{8}$/.test(soloDigitosNacionales(valor));
}

/** Mientras se escribe: "9 2608 0216". El +56 lo pone el campo. */
export function formatearNacional(valor: string): string {
  const n = soloDigitosNacionales(valor);
  if (n.length <= 1) return n;
  if (n.length <= 5) return `${n[0]} ${n.slice(1)}`;
  return `${n[0]} ${n.slice(1, 5)} ${n.slice(5)}`;
}

/** Como se manda al backend: "+56912345678". */
export function telefonoCanonico(valor: string): string {
  const n = soloDigitosNacionales(valor);
  return n ? `+56${n}` : '';
}

/** Vacío no es inválido: de eso se encarga `Validators.required` si aplica. */
export function validadorDeTelefono(control: AbstractControl): ValidationErrors | null {
  const valor = (control.value ?? '').toString();
  if (!valor.trim()) return null;
  return esTelefonoChilenoValido(valor) ? null : { telefono: true };
}
